module.exports = "/_next/static/images/8389e2622eef71f260d844d05ac879b8-nubanker-tpm@0.75x.jpg.webp";